// extracted by mini-css-extract-plugin
export var arrow = "styles-module--arrow--F829R";